import { Theme, Grid, Paper, Container } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import { GridColumnVisibilityModel, GridSortDirection, GridSortItem, GridSortModel } from '@mui/x-data-grid';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Paging from '../../interfaces/common/paging';
import { RootState } from '../../setup';
import Pagination from '../../interfaces/common/pagination';
import IMenuItem from '../../interfaces/common/menuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MainLayout from '../common/widgets/mainLayout';
import LanguageUtils from '../../utils/LanguageUtils';
import UrlConstants from '../../constants/UrlConstants';
import ProductArena from '../../interfaces/output/productArena';
import ProductArenaFilters from '../../interfaces/filters/productArenaFilters';
import { fetchProductArenas, getProductArenas, isLoadingProductArenas, resetProductArenas } from '../../reducers/productArenaReducer';
import PageUtils from '../../utils/pageUtils';
import ProductArenaFilterComponent from './ProductArenaFilterComponent';
import ProductArenaList from './productArenaList';

interface IProductArenasProps {
    productArenas: Pagination<ProductArena>;
    classes: any;
    fetchProductArenas : any;
    isLoading: boolean;
    onChange: () => void;
    resetProductArenas: () => void;
    fetch: any;
}

interface IProductArenasState {
    filters: ProductArenaFilters;
    paging: Paging;
    menuItem: IMenuItem;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const messages = {
    productArenas: LanguageUtils.createMessage('Product Arenas'),
    add: LanguageUtils.createMessage('Add')
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchProductArenas: (paging: Paging, filters: ProductArenaFilters) => dispatch(fetchProductArenas({
        paging,
        filters
    })),
    resetProductArenas: () => dispatch(resetProductArenas())

});

const mapStoreToProps = (store: RootState) => {
    return {
        productArenas: getProductArenas(store),
        isLoading: isLoadingProductArenas(store)
    };
};

const styles = (theme: Theme) => createStyles({
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    }
});

class ProductArenas extends Component<IProductArenasProps, IProductArenasState> {
    terminalsListRef: any;
    constructor(props: IProductArenasProps) {
        super(props);
        this.terminalsListRef = React.createRef();

        this.state = {
            filters: {} as ProductArenaFilters,
            paging: PageUtils.getDefaultPaging(),
            menuItem: {
                id: 1,
                name: messages.productArenas,
                icon: <FontAwesomeIcon icon="warehouse" size="1x" transform="grow-7" />,
                isSelected: false
            },
            sortModel: [{
                field: '',
                sort: '' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {}
        };
    }

    componentDidMount() {
        const { fetchProductArenas } = this.props;
        const { paging, filters } = this.state;

        fetchProductArenas(paging, filters);
    }

    componentWillUnmount() {
        const { resetProductArenas } = this.props;
        resetProductArenas();
    }

    applyFilters = () => {
        const { fetchProductArenas } = this.props;
        const { paging, filters } = this.state;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };
        this.setState({
            paging: newPagination
        });

        fetchProductArenas(newPagination, filters);

        if(this.terminalsListRef !== null && this.terminalsListRef !== undefined &&
            this.terminalsListRef.current !== null && this.terminalsListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.terminalsListRef.current.resetDataGridPage();
        }
    }

    onChange = (attribute: string, value: any) => {
        const { filters, paging } = this.state;

        const newFilter = { ...filters } as ProductArenaFilters;
        (newFilter as any)[attribute] = value;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };

        this.setState({
            filters: newFilter,
            paging: newPagination
        });
    }

    setDefaultState = () => {
        const { fetchProductArenas } = this.props;
        const { paging } = this.state;

        const newFilters = {
        } as ProductArenaFilters;

        const newSortModel = [{
            field: 'id',
            sort: 'asc'
        }] as GridSortModel;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page,
            sort: newSortModel
        };

        this.setState({
            paging: newPagination,
            filters: newFilters
        });

        fetchProductArenas(newPagination, newFilters);

        if(this.terminalsListRef !== null && this.terminalsListRef !== undefined &&
            this.terminalsListRef.current !== null && this.terminalsListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.terminalsListRef.current.resetDataGridPage();
        }
    }

    _onSortChange = (newModel: GridSortModel) => {
        const { fetchProductArenas } = this.props;
        const { sortModel, filters, paging } = this.state;

        if(JSON.stringify(sortModel) !== JSON.stringify(newModel)) {
            const newPaging = {
                ...paging,
                sort: newModel
            };

            this.setState({
                sortModel: newModel,
                paging: newPaging
            });

            fetchProductArenas(newPaging, filters);

        }
    }

    render() {
        const { classes, productArenas, fetchProductArenas, isLoading } = this.props;
        const { paging, filters, menuItem, columnVisibilityModel } = this.state;

        return (
            <MainLayout menuItem={menuItem}>
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <ProductArenaFilterComponent
                                    actions={[{
                                        text: messages.add,
                                        icon: 'plus',
                                        href: `${UrlConstants.PRODUCT_ARENAS}/add`
                                    }]}
                                    applyFilters={this.applyFilters} setDefaultState={this.setDefaultState} filters={filters} onChange={this.onChange} />
                                <ProductArenaList rows={productArenas} isLoading={isLoading}
                                    ref={this.terminalsListRef}
                                    onPageChange={(nextPage: number, nextSize: number) => {
                                        const newPage = {
                                            ...paging,
                                            page: nextPage,
                                            size: nextSize
                                        };
                                        fetchProductArenas(newPage, filters);
                                        this.setState({ paging: newPage });
                                    }}
                                    onSortModelChange={(sortModel: GridSortModel) => this._onSortChange(sortModel)}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel: GridColumnVisibilityModel) =>
                                        this.setState({
                                            columnVisibilityModel: newModel
                                        })
                                    }
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(ProductArenas));